//全局变量
export default {
  install(Vue, options) {
    //用户类型 老师 1   学生 2
    Vue.prototype.identity = {
      teacher: 1,
      student: 2
    };
    // 云课件用户类型
    Vue.prototype.userType = {
      free: 100, // 免费用户
      pay: 101, //  付费用户
      experience: 102 //体验用户
    };
    //课时类型 新授课 1  复习课 2
    Vue.prototype.courseType = {
      new: 1,
      review: 2
    }

    //课时类型 自定义课1 非自定义课0
    Vue.prototype.courseIsCustom = {
      isCustom: 1,
      noCustom: 0
    }
    Vue.prototype.getTitle = {
      title: 'akadm4.0',
      isBack: true,
      isAdd: false,
    };
    //媒体类型ID  媒体类型id 1 视频 2 音频 4 文档 5 ppt 6 图片 101试题
    Vue.prototype.media_type_id = {
      video: 1,
      audio: 2,
      doc: 4,
      ppt: 5,
      image: 6,
      html: 9,
      exam: 100,
      exam_question: 101,
      exam_card: 200,
      excel: 10001,
      limit_exam: 105
    };
    Vue.prototype.media_type_map_class = {
      1: "video",
      2: "audio",
      4: "doc",
      5: "ppt",
      6: "img",
      9: "html",
      100: "exam",
      200: "exam_card",
      10001: "excel",
      105: 'limit_exam',
    };
    Vue.prototype.media_type_zn = {
      1: '视频',
      2: '音频',
      4: '文档',
      5: 'PPT',
      6: '图片',
      9: '富文本资源',
      101: '试题'
    };
    //视频播放类型
    Vue.prototype.videoPlatformConfig = {
      "CDN": -100,
      "LOCAL": -1,
      "YOUKU": 1,
      "YangCong": 2,
      "ZOUQI": 3,
      "LELE": 4
    };
    //音频播放类型
    Vue.prototype.audioPlatformConfig = {
      "LOCAL": -1,
      "QINIU": -2
    };
    //图片展示类型
    Vue.prototype.imagePlatformConfig = {
      "LOCAL": -1,
      "QINIU": -2,
    };
    //文档
    Vue.prototype.docPlatformConfig = {
      "LOCAL": -1,
      "QINIU": -2,
      "WEB_SERVER": -200
    };
    //洋葱
    Vue.prototype.videoYangCongConfig = {
      "q": "akadm",
      "share": false
    };
    //上传视频类型
    Vue.prototype.uploaderType = {
      admin: 1,
      teacher: 2
    };
    //试卷题目类型  单选题 1   多选题 2  解析题 3   阅读题 4   客观填空题 7   听力题8   判断题 9  听力填空题11 听力阅读题12
    Vue.prototype.questionType = {
      single: 1,
      multiple: 2,
      analysis: 3,
      read: 4,
      pack: 7,
      hearing: 8,
      judge: 9,
      hearingPack: 11,
      hearingRead: 12,
    };
    //麦穗型号
    Vue.prototype.deviceInfo = [{
      "brand": "StuBook",
      "model": "M1072"
    }, {
      "brand": "WHEATEK",
      "model": "M1023"
    }, {
      "brand": "KTE",
      "model": "p23l_e221_fhd_5m"
    }, {
      "brand": "P102WIFI",
      "model": "P102WIFI"
    }],
      Vue.prototype.imApp = {
        //回调事件名称
        OPEN_DRAW_BOARD_SUCCESS: "open_draw_board_success",
        CLOSE_DRAW_BOARD_SUCCESS: "close_draw_board_success",
        GET_DRAW_BOARD_IMG_DATA_SUCCESS: "get_draw_board_img_data_success",
        ENABLE_DRAW_BOARD_ERASER_SUCCESS: "enable_draw_board_eraser_success",
        CLEAN_DRAW_BOARD_SUCCESS: "clean_draw_board_success",
        onMsg: function (event, msg, data) {
          //需要回调处理可以从这里进行
          switch (event) {
            case this.OPEN_DRAW_BOARD_SUCCESS:
              break;
            case this.CLOSE_DRAW_BOARD_SUCCESS:
              break;
            case this.GET_DRAW_BOARD_IMG_DATA_SUCCESS:
              break;
            case this.ENABLE_DRAW_BOARD_ERASER_SUCCESS:
              break;
            case this.CLEAN_DRAW_BOARD_SUCCESS:
              break;
            default:
              alert("未处理事件名:" + event);

          }
        }
      },
      Vue.prototype.entryNone = {
        //首页-学情统计、添加课时、
        index: {
          study: {
            state: false,
          },
          addCourse: {
            state: false,
          },
        },
        //个人中心-只留资源试题 个人资料
        personalCenter: {
          commonResource: {
            state: false,
          },
          classManage: {
            state: false,
          },
          questionCenter: {
            state: false,
          },
          myCollect: {
            state: false,
          },
          systemNoc: {
            state: false,
          },

        },
        //备课 更多试卷  我的收藏
        PrepareCourseIndex: {
          moreExam: {
            state: false,
          },
        }
      },
      //答题卡题目类型  问题类型 1：选择题 2：判断题 3：填空题 4：解析题 5：简答题
      Vue.prototype.anserSheetType = {
        choose: 1,
        judge: 2,
        pack: 3,
        analysis: 4,
        short: 5
      }
    //答题卡题目类型  问题类型 1：选择题 2：判断题 3：填空题 4：解析题 5：简答题
    Vue.prototype.anserSheetTypeFont = {
      1: "选择",
      2: "判断",
      3: "填空",
      4: "解析",
      5: "简答"
    },
      //错误上报类型 1 api类型报错   2 其他类型报错
      Vue.prototype.apiErrorType = {
        api: 1,
        api_error_code: 2,
        client: 3
      },
      // 客户端请求二维码type值
      Vue.prototype.getQrCodeType = {
        electronLogin: 1, // 客户端登陆
        bindAccount: 2, // pc绑定账号
        login: 3, // 爱米云助教登陆
        resetPwd: 4, // 扫码修改密码
        mapping: 5, // 小程序跳转到投图页
      };
    // 客户端请求二维码from值
    Vue.prototype.getQrCodeFrom = {
      electron: 1, // 客户端登陆
      personalCenter: 2, // 个人中心登录
      mapping: 5, // 小程序跳转到投图页
      teacherIndex: 6, // 教师首页
    };
    // 登录接口区分来源
    Vue.prototype.loginFrom = {
      akadm: 100, // 爱米云助教
      miniTeacher: 200, // 教师小程序
      miniStudent: 201, // 学生小程序 
      electron: 300, // 云课件
    };
  },

}